export const ChooseProgramPopupTestIds = {
  CANCEL_BUTTON: 'choose-program-popup.cancel-button',
  CHANGE_PROGRAM_BUTTON: 'choose-program-popup.change-program-button',
};
